import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { chatImagesSelector } from '../../selectors/chatImagesSelector';
import { userProfileClientInfoSelector, userProfileStatusSelector } from '../../selectors/userProfile';
import { EUserCardTab } from '../../components/UserCard/UserCardSwitcher/types';
import { ERequestApiStatus } from '../../types/appState';

const USER_CARD_SWITCHER_TABS = [EUserCardTab.About, EUserCardTab.Photos];

/**
 * Определяет, какие вкладки карточки пользователя нужно показывать, и управляет активной вкладкой.
 * Вкладка выводится только если у неё есть содержимое.
 */
export const useUserCardTabs = () => {
  const images = useSelector(chatImagesSelector);
  const clientInfo = useSelector(userProfileClientInfoSelector);
  const status = useSelector(userProfileStatusSelector);

  const isAboutContentAvailable = Boolean(
    clientInfo?.searchInfo?.tags.length ||
    clientInfo?.statistics?.parameters.length ||
    clientInfo?.recentlyWatchedOffers?.offers.length ||
    clientInfo?.promo?.features.length,
  );
  // Пока профиль загружается или запрос упал, вкладку нужно показать, чтобы отрендерить лоадер/ошибку.
  const isAboutRequestActive = status === ERequestApiStatus.Pending || status === ERequestApiStatus.Failed;
  const isAboutTabVisible = isAboutContentAvailable || isAboutRequestActive;
  const hasPhotosContent = !!images?.files?.length;

  const tabs = useMemo(
    () => USER_CARD_SWITCHER_TABS.filter(tab => (tab === EUserCardTab.About ? isAboutTabVisible : hasPhotosContent)),
    [isAboutTabVisible, hasPhotosContent],
  );

  const [activeTab, setActiveTab] = useState<EUserCardTab | null>(null);

  const resolvedActiveTab = activeTab && tabs.includes(activeTab) ? activeTab : (tabs[0] ?? null);

  return { tabs, activeTab: resolvedActiveTab, setActiveTab };
};
